import { takeLatest, put, call, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { getMessageContentCM } from 'yoda-interfaces/lib/Content/ContentApi';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';
import { creditCardBannerConst } from '../helpers/ProductConstants';
import * as actionTypes from '../actionTypes/CMCreditCardBannerDataActionTypes';

const checkCMDataAvailable = (cmRowData) => {
    const isPlacementDataEmpty = cmRowData?.placements
        .filter((placement) => placement?.name === 'SF')
        .every((placement) => placement?.items?.length === 0);
    return isPlacementDataEmpty;
};

function* CMcreditCardBannerSaga(action) {
    try {
        const { enableCMFragments = true } = yield select(selectFeatureFlags);
        const payload = {
            isChannelRequired: true,
            skipExtractUIContent: true,
            searchTerm: get(
                action,
                'payload.searchTerm',
                creditCardBannerConst.CREDIT_CARD_BANNER_TYPE
            ),
        };
        const imageContent = yield call(getMessageContentCM, {
            payload,
            isCMHeaderRequired: enableCMFragments,
        });
        const cmRowData = get(imageContent, 'content.page.grid', {});
        const isCMComponentDataEmpty = Object.keys(cmRowData).length
            ? checkCMDataAvailable(cmRowData)
            : false;
        if (imageContent?.status !== 200 || isCMComponentDataEmpty) {
            yield put({
                type: actionTypes.SET_CM_CREDIT_CARD_BANNER_DATA,
                content: get(imageContent, 'content.page', {}),
                isError: true,
            });
        } else {
            yield put({
                type: actionTypes.SET_CM_CREDIT_CARD_BANNER_DATA,
                content: get(imageContent, 'content.page', {}),
                isError: false,
            });
        }
    } catch (error) {
        yield put({
            type: actionTypes.GET_CM_CREDIT_CARD_BANNER_DATA_ERROR,
            errorHandlerInfo: error,
        });
    }
}

const watchCMCreditCardBannerSaga = function* watchCMCreditCardBannerSaga() {
    yield takeLatest(actionTypes.GET_CM_CREDIT_CARD_BANNER_DATA, CMcreditCardBannerSaga);
};
watchCMCreditCardBannerSaga.sagaName = 'watchCMCreditCardBannerSaga';

export default watchCMCreditCardBannerSaga;
